import { render } from "./EventList.vue?vue&type=template&id=4af2499e&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=4af2499e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\AnnaKraher\\Desktop\\AlgorithmWatch\\Scripts\\Automatisierung_Presse\\tool\\aw-press-events\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af2499e"]])

export default __exports__